import { Button } from '@creanizer/ui'
import { Card } from '@creanizer/ui'
import { Copy, MapPin, Building, Users, AlertCircle, Landmark, Coins } from 'lucide-react'
import type { CommunityFeatures } from '@creanizer/types'

interface CommunityFeaturesProps {
  features: CommunityFeatures
  onCopy: (text: string) => void
}

export function CommunityFeatures({ features, onCopy }: CommunityFeaturesProps) {
  const formatFeatures = () => {
    const lines: string[] = []
    lines.push('■ 地理的特徴')
    lines.push(features.geography)
    lines.push('')
    lines.push('■ 主要施設')
    lines.push(features.facilities)
    lines.push('')
    lines.push('■ 文化')
    lines.push(features.culture)
    lines.push('')
    lines.push('■ 問題')
    lines.push(features.problems)
    lines.push('')
    lines.push('■ 政治')
    lines.push(features.politics)
    lines.push('')
    lines.push('■ 経済')
    lines.push(features.economy)
    return lines.join('\n')
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">特徴</h3>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onCopy(formatFeatures())}
        >
          <Copy className="h-4 w-4 mr-1" />
          コピー
        </Button>
      </div>

      <div className="grid gap-4">
        <Card className="p-4">
          <div className="flex items-start gap-3">
            <MapPin className="h-5 w-5 text-blue-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">地理的特徴</h4>
              <p className="text-sm leading-relaxed">{features.geography}</p>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <div className="flex items-start gap-3">
            <Building className="h-5 w-5 text-green-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">主要施設</h4>
              <p className="text-sm leading-relaxed">{features.facilities}</p>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <div className="flex items-start gap-3">
            <Users className="h-5 w-5 text-purple-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">文化</h4>
              <p className="text-sm leading-relaxed">{features.culture}</p>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-red-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">問題</h4>
              <p className="text-sm leading-relaxed">{features.problems}</p>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <div className="flex items-start gap-3">
            <Landmark className="h-5 w-5 text-indigo-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">政治</h4>
              <p className="text-sm leading-relaxed">{features.politics}</p>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <div className="flex items-start gap-3">
            <Coins className="h-5 w-5 text-amber-500 mt-1" />
            <div className="flex-1">
              <h4 className="font-semibold mb-2">経済</h4>
              <p className="text-sm leading-relaxed">{features.economy}</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}